import React from 'react';
import DialogActionsMui from '@material-ui/core/DialogActions';
import { DialogActionsProps } from '@material-ui/core';

export const DialogActions: React.FC<DialogActionsProps> = ({ children, ...rest }) => {
	return <DialogActionsMui {...rest}>{children}</DialogActionsMui>;
};
